import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { uniqueId } from 'lodash';
import { mapActions } from 'vuex';
export default {
  data: function data() {
    return {
      dataDisplay: '',
      keyNameToSet: '',
      valueToSet: '',
      keyNameList: [],
      keyNameToDelete: ''
    };
  },
  watch: {
    keyNameToDelete: function keyNameToDelete(value) {
      if (value) {
        this.handleDelete(value);
      }
    }
  },
  mounted: function mounted() {
    this.load();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/db', ['database', 'databaseClear'])), {}, {
    /**
     * 加载本地数据
     */
    load: function load() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var db;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.database({
                  user: true
                });

              case 2:
                db = _context.sent;
                _this.dataDisplay = JSON.stringify(db.value(), null, 2);
                _this.keyNameList = Object.keys(db.value()).map(function (k) {
                  return {
                    value: k,
                    label: k
                  };
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * 删除一个字段
     */
    handleDelete: function handleDelete(name) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var db;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.database({
                  user: true
                });

              case 2:
                db = _context2.sent;
                db.unset(name).write();

                _this2.load();

                _this2.keyNameToDelete = '';

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * 清空当前用户的数据
     */
    handleClear: function handleClear() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.databaseClear({
                  user: true
                });

              case 2:
                _this3.load();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * 添加一个数据
     */
    handleSet: function handleSet() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var db;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.keyNameToSet === '')) {
                  _context4.next = 3;
                  break;
                }

                _this4.$message.error('字段名不能为空');

                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return _this4.database({
                  user: true
                });

              case 5:
                db = _context4.sent;
                db.set(_this4.keyNameToSet, _this4.valueToSet).write();

                _this4.load();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * 添加一个随机数据
     */
    handleSetRandom: function handleSetRandom() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var id, db;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                id = uniqueId();
                _context5.next = 3;
                return _this5.database({
                  user: true
                });

              case 3:
                db = _context5.sent;
                db.set("uniqueKey".concat(id), "value".concat(id)).write();

                _this5.load();

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  })
};